import { render, staticRenderFns } from "./ViolationsCrud.vue?vue&type=template&id=72a7042c"
import script from "./ViolationsCrud.vue?vue&type=script&lang=js"
export * from "./ViolationsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports